<template>
  <screening-workflow-panel
    :review="review"
    :current-researcher="currentResearcher"
    :pending-connection.sync="referencesVotedOnConnection"
    :pending-connection-query="
      $apollo.queries.referencesVotedOnConnection
    "
    :search-input.sync="searchInput"
    :get-vote-by-current-user-func="getVote"
    :revoke-vote-func="revokeVote"
    :filtering-input="filteringInput"
    disable-select-next-on-vote
    restrict-to-voting-only
    hide-on-undo
    :should-hide-reference-func="shouldHideReference"
    :should-hide-reference-based-on-vote-func="doNothing"
    @clear-filtering-input="$emit('clear-filtering-input')"
  >
    <template #empty-state>
      <screen-tab-complete-empty-state />
    </template>
  </screening-workflow-panel>
</template>

<script>
import ScreeningWorkflowPanel from './ScreeningWorkflowPanel';
import ScreenTabCompleteEmptyState from './ScreenTabCompleteEmptyState';
import { GetReferencesByScreeningVoteHistory } from '@/graphql';
import {
  Review,
  Researcher,
  ReferenceOffsetConnection,
  ReferenceFilteringInputDto,
} from '@/models';
import { isEqual } from 'lodash';
import { mapActions } from 'vuex';

const PAGE_SIZE = 50;

export default {
  name: 'ScreenTabComplete',
  components: {
    ScreeningWorkflowPanel,
    ScreenTabCompleteEmptyState,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
    filteringInput: {
      type: ReferenceFilteringInputDto,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clear-filtering-input'],
  data: () => ({
    searchInput: null,
    referencesVotedOnConnection: null,
    hiddenReferenceMap: {},
    doNothing: () => {},
  }),
  apollo: {
    referencesVotedOnConnection: {
      query: GetReferencesByScreeningVoteHistory,
      variables() {
        return {
          reviewId: this.review.id,
          limit: PAGE_SIZE,
          searchQuery: this.searchInput || null,
          hasTag: this.filteringInput.hasTag,
          hasKeyword: this.filteringInput.hasKeyword,
          hasAuthor: this.filteringInput.hasAuthor,
          hasPlacePublished: this.filteringInput.hasPlacePublished,
        };
      },
      update: (data) => {
        return new ReferenceOffsetConnection(
          data.referencesByScreeningVoteHistory
        );
      },
      skip() {
        return !this.review?.id;
      },
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
    },
  },
  watch: {
    active(active) {
      if (active && this.referencesVotedOnConnection) {
        this.$apollo.queries.referencesVotedOnConnection.refetch();
      }
    },
    filteringInput(newInput, oldInput) {
      // Clear the cache when the filtering input changes to show the loading state.
      const changed = !isEqual(newInput, oldInput);
      if (this.active && changed) {
        this.referencesVotedOnConnection = null;
      }
    },
  },
  methods: {
    ...mapActions({
      revokeVote: 'reviewerScreeningVote/deleteWithCacheUpdate',
    }),
    getVote(reference) {
      return reference?.getScreeningVoteBy(this.currentResearcher);
    },
    shouldHideReference(reference) {
      return !reference.getScreeningVoteBy(this.currentResearcher);
    },
  },
};
</script>
